module.exports = __webpack_public_path__ + "static/comingsoonvestcsdisc-3315304b88c9bca2c1ddc6fb5622a56a.jpeg";